import React, { useState } from 'react'

import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Alert from '@material-ui/lab/Alert'
import LinearProgress from '@material-ui/core/LinearProgress'

import { setToken, setUser, setUserId } from '../../utils/auth'
import { getUrlService, log } from '../../utils'

function MadeWithLove() {
  return (
    <Typography variant='body2' color='textSecondary' align='center'>
      {'Copyright '}
      <Link color='inherit' href='https://www.aria.fr/'>
        ARIA Technologies
      </Link>
      {' 2020.'}
    </Typography>
  )
}

const useStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.background
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  alert: {
    marginTop: theme.spacing(1),
    width: '100%'
  },
  linearProgress: {
    marginTop: theme.spacing(1),
    height: '5px',
    width: '100%'
  }
}))

// ////////////////////
// Render Function
// ////////////////////
export default function LogIn({ tokenHandler, anonymous }) {
  const classes = useStyles()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)

  const onLogin = React.useCallback(
    (username, password) => {
      setIsLoading(true)
      setError(false)

      const authserv = process.env.REACT_APP_API_AUTH_SERVICE || 'api-token'
      const _url = getUrlService(authserv)
      log(_url)
      // eslint-disable-next-line no-undef
      fetch(_url, {
        method: 'POST',
        body: JSON.stringify({
          username: username,
          password: password,
          group: process.env.REACT_APP_PROJECT
        }),
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        }
      })
        .then((response) => {
          if (response.status === 200) {
            return response.json()
          } else if (response.status === 403) {
            return response.json()
          } else if (response.status === 404) {
            const errmsg = 'Authentication service not found'
            setError(errmsg)
            setIsLoading(false)
            return Promise.reject(new Error(errmsg))
          } else if (response.status === 401) {
            const errmsg = response.statusText || 'No handled error'
            setError(errmsg)
            setIsLoading(false)
            return Promise.reject(new Error(errmsg))
          } else {
            const errmsg = response.statusText || 'No handled error'
            setError(errmsg)
            setIsLoading(false)
            return Promise.reject(new Error(errmsg))
          }
        })
        .then((user) => {
          setIsLoading(false)

          if (user) {
            if (user.name) {
              setUser(user.name)
            }
            if (user.id) {
              setUserId(user.id)
            }

            if (user.token && user.id) {
              //!!! First set token in cookie
              setToken(user.token)

              //!!! Second set token in tokenHandler
              if (typeof tokenHandler === 'function') {
                tokenHandler(user.token, user.id)
              }
            }

            if (user.error) {
              console.error(user.message)
              setError(user.message)
            }
          }
        })
        .catch((error) => {
          console.error(error)
          setError(error.toString())
          setIsLoading(false)
        })
    },
    [tokenHandler]
  )

  React.useEffect(() => {
    if (typeof anonymous == 'object') {
      setTimeout(() => {
        onLogin(anonymous.username, anonymous.password)
      }, 500)
    }
  }, [anonymous, onLogin])

  return (
    <React.Fragment>
      {typeof anonymous == 'undefined' ? (
        <Container component='main' maxWidth='xs'>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component='h1' variant='h5'>
              Sign in
            </Typography>
            <form
              className={classes.form}
              noValidate
              onSubmit={(e) => {
                e.preventDefault()
                return false
              }}
            >
              <TextField
                variant='outlined'
                margin='normal'
                required
                fullWidth
                id='username'
                label='Login'
                name='username'
                autoComplete='username'
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <TextField
                variant='outlined'
                margin='normal'
                required
                fullWidth
                name='password'
                label='Mot de passe'
                type='password'
                id='password'
                autoComplete='current-password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              {/* <FormControlLabel
                control={<Checkbox value='remember' color='primary' />}
                label='Remember me'
              /> */}
              <Button
                type='submit'
                fullWidth
                variant='contained'
                color='primary'
                className={classes.submit}
                onClick={() => onLogin(username, password)}
              >
                Login
              </Button>
              <Grid container>
                {/* <Grid item xs>
                  <Link href='#' variant='body2'>
                    Forgot password?
                  </Link>
                </Grid> */}
                <Grid item>
                  <Link href='https://climat-c.tn/INM/web/creation-compte-developpeur' target="_parent" variant='body2'>
                    Pas de compte ? Création d'un nouveau compte
                  </Link>
                </Grid>
              </Grid>
            </form>
            {isLoading && <LinearProgress className={classes.linearProgress} />}
            {error && (
              <Alert severity='error' className={classes.alert}>
                Login ou Mot de passe est incorrect !
              </Alert>
            )}
          </div>
          <Box mt={5}>
            <MadeWithLove />
          </Box>
        </Container>
      ) : (
        error && (
          <Container component='main' maxWidth='xs'>
            <div className={classes.paper}>
              <Alert severity='error' className={classes.alert}>
                Problème d'authentification !
              </Alert>
            </div>
          </Container>
        )
      )}
    </React.Fragment>
  )
}
